<button class="link-button" (click)="onClick.emit($event)" [disabled]="disabled">
  <ng-content></ng-content>
</button>
